<!-- CountdownTimer.vue -->
<template>
  <div>
    <p v-if="expired" class="expired">Expired</p>
    <p v-else-if="status === 'PRG'" class="countdown">{{ formattedTime }}</p>
    <p v-else class="countdown">NOT STARTED</p>
  </div>
</template>

<script>
export default {
  props: {
    startTime: {
      type: Date,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      countdownTime: 4 * 60 * 60 * 1000, // 4 jam dalam milidetik
      timeRemaining: 0,
      expired: false,
      timer: null
    };
  },
  computed: {
    formattedTime() {
      const hours = Math.floor(this.timeRemaining / (1000 * 60 * 60));
      const minutes = Math.floor((this.timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((this.timeRemaining % (1000 * 60)) / 1000);
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
  },
  watch: {
    status: {
      immediate: true,
      handler(newVal) {
        if (newVal === 'inprogress') {
          this.calculateTimeRemaining();
          this.timer = setInterval(this.calculateTimeRemaining, 1000);
        } else if (this.timer) {
          clearInterval(this.timer);
        }
      }
    }
  },
  methods: {
    calculateTimeRemaining() {
      const currentTime = new Date().getTime();
      const endTime = new Date(this.startTime.getTime()) + this.countdownTime;
      this.timeRemaining = endTime - currentTime;
      if (this.timeRemaining <= 0) {
        this.timeRemaining = 0;
        this.expired = true;
        clearInterval(this.timer);
      }
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
};
</script>

<style>
h2 {
  font-family: Arial, sans-serif;
}
p {
  font-size: 24px;
  font-weight: bold;
}
.countdown {
  color: red;
}
.expired {
  color: red;
}
</style>
